// extracted by mini-css-extract-plugin
export default {"Container":"StatBox_Container__tFA8T"};